import { theme } from '../../../theme';
import { getResponsiveSize } from '../../../utils';

export const dateRangePickerStyles = {
  dateRangePicker: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    width: '35%',
    ml: 'auto',
    border: `1px solid ${theme.palette.myPrimary.lightBlue100}`,
    borderRadius: theme.palette.propVars.borderRadius,
    cursor: 'pointer',
    px: getResponsiveSize(4),
    py: getResponsiveSize(2),
    '&.open': {
      boxShadow: `0 2px 4px 4px ${theme.palette.myPrimary.lightBlue100}40`,
    },
    '& .MuiFormControl-root.range-input': {
      '& .MuiFormLabel-root': {
        pl: getResponsiveSize(6),
        transform: `translate(${getResponsiveSize(8)}, calc(${getResponsiveSize(
          8,
        )})) scale(1)`,

        '&.Mui-focused': {
          transform: `translate(${getResponsiveSize(
            8,
          )}, calc(${getResponsiveSize(8)})) scale(1)`,
          background: theme.palette.myPrimary.white,
          pr: getResponsiveSize(6),
        },
        '&.MuiFormLabel-filled': {
          transform: `translate(${getResponsiveSize(
            8,
          )}, calc(${getResponsiveSize(9)}* -1)) scale(0.75)`,
          background: theme.palette.myPrimary.white,
          pr: getResponsiveSize(6),
        },
      },
      '& .MuiInputBase-root': {
        p: 0,
        '&.Mui-disabled .MuiInputBase-input': {
          color: theme.palette.neutral.grey70,
          WebkitTextFillColor: 'unset',
        },
        '& .MuiInputBase-input': {
          cursor: 'pointer',
          p: 0,
          py: getResponsiveSize(8),
          pl: getResponsiveSize(14),
        },
        '& fieldset': {
          border: 'none',
        },
      },
    },
    '& .date-select': {
      mr: getResponsiveSize(6),
      '& svg': {
        width: getResponsiveSize(20), // 20px
        height: getResponsiveSize(20), // 20px
        stroke: theme.palette.myPrimary.lightBlue70,
        fill: 'transparent',
      },
    },
    '& .reset svg': {
      width: getResponsiveSize(20), // 20px
      height: getResponsiveSize(20), // 20px
      color: theme.palette.myPrimary.lightBlue70,
    },
    '& .arrow-to': {
      color: theme.palette.myPrimary.lightBlue70,
    },
  },
  pickerPopover: {
    '& .MuiPaper-root': {
      mt: getResponsiveSize(8),
      borderRadius: getResponsiveSize(12), // 12px
      border: `1px solid ${theme.palette.myPrimary.lightBlue70}`,
      '& .rdrDateDisplayWrapper': {
        display: 'none',
      },
      '& .rdrMonths': {
        '& .rdrDay': {
          mb: '4px',
          '&:not(.rdrDayPassive,.rdrDayDisabled) rdrDayNumber span': {
            color: theme.palette.neutral.grey80,
          },
          '& .rdrDayNumber': {
            width: '100%',
            height: '100%',
            top: 0,
            bottom: 0,
            fontSize: '14px',
            fontFamily: theme.typography.mainFontFamily,
          },
          '& .rdrDayStartPreview, .rdrDayEndPreview': {
            height: '100%',
            top: 0,
            borderRadius: '6px',
            background: theme.palette.myPrimary.lightBlue100,
            '&~ .rdrDayNumber span': {
              color: theme.palette.myPrimary.white,
              zIndex: 1,
            },
          },
          '& .rdrDayStartPreview:not(.rdrDayEndPreview)': {
            boxShadow: `4px 0 0 0 ${theme.palette.myPrimary.lightBlue70}`,
          },
          '& .rdrDayEndPreview:not(.rdrDayStartPreview)': {
            boxShadow: `-4px 0 0 0 ${theme.palette.myPrimary.lightBlue70}`,
          },
          '& .rdrStartEdge, .rdrEndEdge': {
            height: '100%',
            top: 0,
            borderRadius: '6px',
            // selected dates
            '&~ .rdrDayNumber span': {
              color: theme.palette.myPrimary.white,
            },
          },
          '& .rdrStartEdge:not(.rdrEndEdge)': {
            boxShadow: `4px 0 0 0 ${theme.palette.myPrimary.lightBlue70}`,
          },
          '& .rdrEndEdge:not(.rdrStartEdge)': {
            boxShadow: `-4px 0 0 0 ${theme.palette.myPrimary.lightBlue70}`,
          },
          '& .rdrInRange': {
            height: '100%',
            top: 0,
            bottom: 0,
            background: theme.palette.myPrimary.lightBlue70,
          },
          '&.rdrDayEndOfWeek, &.rdrDayEndOfMonth': {
            '& .rdrDayInPreview, & .rdrDayStartPreview, & .rdrInRange': {
              borderTopRightRadius: '6px',
              borderBottomRightRadius: '6px',
            },
          },
          '&.rdrDayStartOfWeek, &.rdrDayStartOfMonth': {
            '& .rdrDayInPreview, & .rdrDayStartPreview, & .rdrInRange': {
              borderTopLeftRadius: '6px',
              borderBottomLeftRadius: '6px',
            },
          },

          // Disabled dates
          '&.rdrDayDisabled:last-of-type': {
            borderTopRightRadius: '6px',
            borderBottomRightRadius: '6px',
          },
          '&.rdrDayDisabled.rdrDayEndOfWeek': {
            borderTopRightRadius: '6px',
            borderBottomRightRadius: '6px',
          },
          '&.rdrDayDisabled.rdrDayStartOfWeek': {
            borderTopLeftRadius: '6px',
            borderBottomLeftRadius: '6px',
          },
          '&:has( .first-disabled-date) ': {
            borderTopLeftRadius: '6px',
            borderBottomLeftRadius: '6px',
          },

          '&.rdrDay:has(.rdrStartEdge) + .rdrDay .rdrEndEdge, &.rdrDay:has(.rdrDayStartPreview) + .rdrDay .rdrDayEndPreview':
            {
              boxShadow: 'none',
              left: '2px',
            },
          '&.rdrDay:has(+ .rdrDay .rdrEndEdge) .rdrStartEdge, &.rdrDay:has(+ .rdrDay .rdrDayEndPreview) .rdrDayStartPreview':
            {
              boxShadow: 'none',
              right: '2px',
            },
          '& .rdrStartEdge': {
            left: '2px',
            '&~ .rdrDayStartPreview.rdrDayEndPreview': {
              left: '2px',
            },
          },
          '& .rdrEndEdge': {
            right: '2px',
            '&~ .rdrDayStartPreview.rdrDayEndPreview': {
              right: '2px',
            },
          },
          '&.rdrDayToday': {
            '& .rdrDayNumber span:after': {
              background: theme.palette.myPrimary.lightBlue100,
            },
          },
          '&.rdrDayToday:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span:after, &.rdrDayToday:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span:after, &.rdrDayToday:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span:after, &.rdrDayToday:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span:after':
            {
              background: theme.palette.myPrimary.white,
            },
        },
        '& .rdrDayInPreview': {
          background: theme.palette.myPrimary.lightBlue70,
          borderStyle: 'dashed',
          height: '100%',
          top: 0,
          '&~ .rdrDayNumber span': {
            color: theme.palette.myPrimary.white,
            zIndex: 1,
          },
        },
        '& .rdrMonthName': {
          fontFamily: theme.typography.mainFontFamily,
          color: theme.palette.neutral.grey70,
          ...theme.palette.propVars.semiBoldFontWeight,
        },
        '& .rdrWeekDays .rdrWeekDay': {
          fontFamily: theme.typography.mainFontFamily,
          ...theme.palette.propVars.regularFontWeight,
        },
      },
      '& .rdrMonthAndYearWrapper': {
        px: '8px',
        '& .month-navigation': {
          '& svg': {
            color: theme.palette.myPrimary.lightBlue70,
          },
        },
        '& .rdrMonthAndYearPickers': {
          gap: '40px',
          mr: '20px',
          '& .MuiFormControl-root': {
            '& .MuiInputBase-root': {
              width: 'auto',
              height: '38px',
              '& .MuiSelect-select': {
                fontSize: '14px',
                py: '4px',
                pl: '12px',
                pr: '32px !important',
              },
            },
            '& .chevron ': {
              width: '24px',
              height: '24px',
              right: '6px',
              '& svg': {
                fontSize: '14px',
              },
            },
          },
          '& .rdrMonthPicker': {},
        },
      },
      '& .date-range-footer': {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        p: '0 10px 10px 18px',
        '& .drf-time-options': {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '8px',
          '& .drf-options-title': {
            mr: 0.5,
            fontSize: '14px',
            color: theme.palette.neutral.grey70,
            ...theme.palette.propVars.semiBoldFontWeight,
          },
        },
        '& .drf-cancel-save': {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '8px',
          '& .cancel': {
            background: 'transparent',
            color: theme.palette.myPrimary.lightBlue100,
            boxShadow: 'none',
            '&:hover': {
              background: theme.palette.neutral.grey4,
            },
          },
        },
        '& .time-range-btn ': {
          p: '8px 12px',
          height: '36px',
          fontSize: '15px',
          ...theme.palette.propVars.semiBoldFontWeight,
          '&.active': {
            backgroundPosition: 'left bottom',
          },
        },
      },
    },
  },
};
